export { default as InputDigit } from './InputDigit';
export type { InputDigitProps } from './InputDigit';
